export default __webpack_public_path__ + "static/media/vendit-kiosk.9e2ca7e2.png";